import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import { topProducer } from "../widgets/Charts";
import Helpers, { windowsActive,number_format } from "../../../../config/Helpers";
import ReactEcharts from "echarts-for-react";
import { Icon } from 'antd';
class TopProducers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            top_segment_table : "",
            top_segment_totals : "",
            top_agency_table : "",
            top_agency_totals : "",
            //echarts_instance : "",
            agency_selected : false,
            last_agency_selected : "",
            chart_producer_option : [],
            top_agencies_filter : 'name',
            top_agencies_sort : {
                key : 'asc',
                value : {
                    a : 1,
                    b : -1
                }
            },
            top_segments_filter : 'name',
            top_segments_sort : {
                key : 'asc',
                value : {
                    a : 1,
                    b : -1
                }
            }
        }
    }

    componentDidMount(){
        //this.state.echarts_instance = this.echarts_react.getEchartsInstance();
        // this.zr = this.echartsInstance.getZr();

        // this.zr.on('legendselectchanged', this.onChartClick);
       
    }

    getOptionTypeBar = (chart) => {
        let self = this;
        let char_keys = Object.keys(this.props.response_request);
        let data = {};
        if (char_keys.length > 0){
            data = this.props.response_request.top_producer.charts[chart]
        }
        let data_agency = this.props.response_request.top_producer.charts["agency"];
        return topProducer(data, -1, data_agency);
    }

    componentWillReceiveProps(props){
        let self = this;
        let char_keys = Object.keys(props.response_request);
        if (char_keys.length > 0){
            const data = props.response_request.top_producer;

            let data_segments = data.charts["segment"];
            let data_agency = data.charts["agency"];
            this.setState({
                chart_producer_option : topProducer(data_segments, -1, data_agency)
            });

            this.initializeStructure(props)
        }
    }
    
    onChartClick = (params)=>{
        //console.log(params);
        let data_agency = this.props.response_request.top_producer.charts['agency'];

        if(params.seriesIndex  == 0){
            if(this.state.last_agency_selected == params.name){
                this.state.agency_selected = !this.state.agency_selected;
            }else{
                this.state.agency_selected = true;
            }
            this.state.last_agency_selected = params.name;

            var index = -1;
            if(this.state.agency_selected){
                index = params.dataIndex;
            }
            var data = this.props.response_request.top_producer.charts['segment'];
            this.setState({
                chart_producer_option : topProducer(data, index, data_agency)
            });
        }
    }
    onChartLegendselectchanged = (params)=>{
        var index = -1;
        if(params.selected[params.name]){
            this.state.agency_selected = true;
        }else{
            this.state.agency_selected = false;
        }

        
    }
    initializeStructure(props){
        const data = props.response_request.top_producer;
        let sgm = Object.assign({}, data.tables.segment);
        let agency = Object.assign({}, data.tables.segment);
        let totals = data.tables.totals;
        var sgm_data = [];

        
        Object.keys(sgm).map((key, index) => {
            var new_sgm = true;
            var array_segment = [];
            Object.keys(sgm_data).map((key_data, index_data) => {
                if(sgm[key].segment.name == sgm_data[key_data].name){
                    sgm_data[key_data].room_nights = sgm_data[key_data].room_nights + sgm[key].room_nights;
                    sgm_data[key_data].revenue = sgm_data[key_data].revenue + sgm[key].revenue;
                    new_sgm = false;
                    if(sgm_data[key_data].room_nights != 0){
                        sgm_data[key_data].adr = sgm_data[key_data].revenue / sgm_data[key_data].room_nights;
                    }
                }
            })
            if(new_sgm){
                var adr = 0;
                if(sgm[key].room_nights != 0){
                    adr = sgm[key].revenue / sgm[key].room_nights;
                }
                array_segment = ({
                    name : sgm[key].segment.name,
                    room_nights : sgm[key].room_nights,
                    revenue : sgm[key].revenue,
                    adr : adr
                });
                sgm_data.push(array_segment);
            }
        })

        if(this.state.top_segments_filter !== ""){
            sgm_data.sort((a, b) => (a[this.state.top_segments_filter] > b[this.state.top_segments_filter]) ? this.state.top_segments_sort.value.a : this.state.top_segments_sort.value.b)
        }else{
            sgm_data.sort((a, b) => (a.name > b.name) ? 1 : 1)
        }
        agency = Object.values(agency)
        if(this.state.top_agencies_filter !== ""){
            if(this.state.top_agencies_filter === 'name'){
                agency.sort((a, b) => (a.agency[this.state.top_agencies_filter] > b.agency[this.state.top_agencies_filter]) ? this.state.top_agencies_sort.value.a : this.state.top_agencies_sort.value.b)
            }else{
                agency.sort((a, b) => (a[this.state.top_agencies_filter] > b[this.state.top_agencies_filter]) ? this.state.top_agencies_sort.value.a : this.state.top_agencies_sort.value.b)
            }
        }

        this.state.top_segment_table = Object.keys(sgm_data).map((key, index) => 
            <div key={"list-current-year-production-"+index} className={"column-grid " + (index % 2 ? "row-c " : "")}>
                <span className="row-grid name">{sgm_data[key].name}</span>
                <span className="row-grid rn">{number_format(sgm_data[key].room_nights,0)}</span>
                <span className="row-grid adr">${number_format(sgm_data[key].adr,2)}</span>
                <span className="row-grid rev">${number_format(sgm_data[key].revenue,2)}</span>
            </div>
        )
        this.state.top_agency_table = Object.keys(agency).map((key, index) => 
            <div key={"list-current-year-production-"+index} className={"column-grid " + (index % 2 ? "row-c " : "")}>
                <span className="row-grid name">{agency[key].agency.name}</span>
                <span className="row-grid rn">{number_format(agency[key].room_nights,0)}</span>
                <span className="row-grid adr">${number_format(agency[key].adr,2)}</span>
                <span className="row-grid rev">${number_format(agency[key].revenue,2)}</span>
            </div>
        )
        this.state.top_segment_totals = (
            <div className={"column-grid totals"}>
                <span className="row-grid name"></span>
                <span className="row-grid rn">{number_format(totals.total_rns_sgm, 0)}</span>
                <span className="row-grid adr">${number_format(totals.total_adr_sgm,2)}</span>
                <span className="row-grid rev">${number_format(totals.total_rev_sgm,2)}</span>
            </div>
        )
        this.state.top_agency_totals = (
            <div className={"column-grid totals"}>
                <span className="row-grid name"></span>
                <span className="row-grid rn">{number_format(totals.total_rns_agency,0)}</span>
                <span className="row-grid adr">${number_format(totals.total_adr_agency,2)}</span>
                <span className="row-grid rev">${number_format(totals.total_rev_agency,2)}</span>
            </div>
        )
    }
    render() {
        let onEvents = {
            'click': this.onChartClick,
            //'pieselectchanged': this.onChartLegendselectchanged
          }
          
        let props = this.props
        let char_keys = Object.keys(props.response_request);
        if (char_keys.length > 0){
            this.initializeStructure(props);
        }
          
        return (
            <section>
                <div className="row">
                    <div className={"datagrid-widget col-md-12 top-producer"}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOP PRODUCERS SEGMENTS AND AGENCIES</span>
                                    
                                    <span className="opt remove-widget hide">
                                        <img src={DeleteFilter} />
                                    </span>
                                </div>
                            </div>
                            <div className="current-values">
                                <div className="row">
                                    
                                </div>
                                <div className="row">
                                    <div className="col-md-12 datagrid-list">
                                        <ReactEcharts
                                            ref={(e) => { this.echarts_react = e; }}
                                            option={windowsActive(this.props, "reservation", "top-producer") === true ? this.state.chart_producer_option : {} }
                                            notMerge={true}
                                            lazyUpdate={true}
                                            theme={"theme_name"}
                                            onEvents={onEvents}
                                            //onChartReady={this.onChartReadyCallback}
                                            
                                        />
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                    {/* <div className={"datagrid-widget col-md-12 top-producer"}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOP PRODUCERS AGENCIES</span>
                                    
                                    <span className="opt remove-widget hide">
                                        <img src={DeleteFilter} />
                                    </span>
                                </div>
                            </div>
                            <div className="current-values">
                                <div className="row">
                                    
                                </div>
                                <div className="row">
                                    <div className="col-md-12 datagrid-list">
                                        <ReactEcharts
                                            option={windowsActive(this.props, "reservation", "top-producer") === true ? this.getOptionTypeBar("agency") : {} }
                                            notMerge={true}
                                            lazyUpdate={true}
                                            theme={"theme_name"}
                                            onChartReady={this.onChartReadyCallback}
                                        /> 
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div> */}
                </div>
                <div className="row">
                    <div className={"datagrid-widget col-md-6 top-producer"}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOP SEGMENTS</span>
                                    
                                    <span className="opt remove-widget hide">
                                        <img src={DeleteFilter} />
                                    </span>
                                </div>
                            </div>
                            <div className="row current-values">
                            <div className="col-md-12 head-current">
                                    <span className="row-grid name cursor-sort" onClick={() => {
                                        let new_sort = {};
                                        let filter = 'name';
                                        if(this.state.top_segments_sort.key !== "asc"){
                                            new_sort = { key : 'asc', value : { a : 1, b : -1 }};
                                        }else{
                                            new_sort = {key : 'desc', value : { a : -1, b : 1 }}
                                        }
                                        this.setState({
                                            top_segments_filter : filter,
                                            top_segments_sort : new_sort
                                        })
                                    }}>NAME 
                                    <Icon 
                                        type={this.state.top_segments_sort.key === 'desc' ? "arrow-down" : 'arrow-up'} 
                                        style={{display : this.state.top_segments_filter === 'name' ? 'inline-block' : 'none'}}/>
                                    </span>
                                    <span className="row-grid rn cursor-sort" onClick={() => {
                                        let new_sort = {};
                                        let filter = 'room_nights';
                                        if(this.state.top_segments_sort.key !== "asc"){
                                            new_sort = { key : 'asc', value : { a : 1, b : -1 }};
                                        }else{
                                            new_sort = {key : 'desc', value : { a : -1, b : 1 }}
                                        }
                                        this.setState({
                                            top_segments_filter : filter,
                                            top_segments_sort : new_sort
                                        })
                                    }}>R/N
                                    <Icon 
                                        type={this.state.top_segments_sort.key === 'desc' ? "arrow-down" : 'arrow-up'} 
                                        style={{display : this.state.top_segments_filter === 'room_nights' ? 'inline-block' : 'none'}}/>
                                    </span>
                                    <span className="row-grid adr cursor-sort" onClick={() => {
                                        let new_sort = {};
                                        let filter = 'adr';
                                        if(this.state.top_segments_sort.key !== "asc"){
                                            new_sort = { key : 'asc', value : { a : 1, b : -1 }};
                                        }else{
                                            new_sort = {key : 'desc', value : { a : -1, b : 1 }}
                                        }
                                        this.setState({
                                            top_segments_filter : filter,
                                            top_segments_sort : new_sort
                                        })
                                    }}>ADR
                                    <Icon 
                                        type={this.state.top_segments_sort.key === 'desc' ? "arrow-down" : 'arrow-up'} 
                                        style={{display : this.state.top_segments_filter === 'adr' ? 'inline-block' : 'none'}}/>
                                    </span>
                                    <span className="row-grid rev cursor-sort" onClick={() => {
                                        let new_sort = {};
                                        let filter = 'revenue';
                                        if(this.state.top_segments_sort.key !== "asc"){
                                            new_sort = { key : 'asc', value : { a : 1, b : -1 }};
                                        }else{
                                            new_sort = {key : 'desc', value : { a : -1, b : 1 }}
                                        }
                                        this.setState({
                                            top_segments_filter : filter,
                                            top_segments_sort : new_sort
                                        })
                                    }}>REV
                                    <Icon 
                                        type={this.state.top_segments_sort.key === 'desc' ? "arrow-down" : 'arrow-up'} 
                                        style={{display : this.state.top_segments_filter === 'revenue' ? 'inline-block' : 'none'}}/>
                                    </span>
                                </div>
                                <div className="col-md-12 datagrid-list scroll-table">
                                    {this.state.top_segment_table}
                                </div>
                                <div className="col-md-12 datagrid-list">
                                    {this.state.top_segment_totals}
                                </div>
                            </div>   
                        </div>
                    </div>
                    <div className={"datagrid-widget col-md-6 top-producer"}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">TOP AGENCIES</span>
                                    
                                    <span className="opt remove-widget hide">
                                        <img src={DeleteFilter} />
                                    </span>
                                </div>
                            </div>
                            <div className="row current-values">
                                <div className="col-md-12 head-current">
                                    <span className="row-grid name cursor-sort" onClick={() => {
                                        let new_sort = {};
                                        let filter = 'name';
                                        if(this.state.top_agencies_sort.key !== "asc"){
                                            new_sort = { key : 'asc', value : { a : 1, b : -1 }};
                                        }else{
                                            new_sort = {key : 'desc', value : { a : -1, b : 1 }}
                                        }
                                        this.setState({
                                            top_agencies_filter : filter,
                                            top_agencies_sort : new_sort
                                        })
                                    }}>NAME 
                                    <Icon 
                                        type={this.state.top_agencies_sort.key === 'desc' ? "arrow-down" : 'arrow-up'} 
                                        style={{display : this.state.top_agencies_filter === 'name' ? 'inline-block' : 'none'}}/>
                                    </span>
                                    <span className="row-grid rn cursor-sort" onClick={() => {
                                        let new_sort = {};
                                        let filter = 'room_nights';
                                        if(this.state.top_agencies_sort.key !== "asc"){
                                            new_sort = { key : 'asc', value : { a : 1, b : -1 }};
                                        }else{
                                            new_sort = {key : 'desc', value : { a : -1, b : 1 }}
                                        }
                                        this.setState({
                                            top_agencies_filter : filter,
                                            top_agencies_sort : new_sort
                                        })
                                    }}>R/N
                                    <Icon 
                                        type={this.state.top_agencies_sort.key === 'desc' ? "arrow-down" : 'arrow-up'} 
                                        style={{display : this.state.top_agencies_filter === 'room_nights' ? 'inline-block' : 'none'}}/>
                                    </span>
                                    <span className="row-grid adr cursor-sort" onClick={() => {
                                        let new_sort = {};
                                        let filter = 'adr';
                                        if(this.state.top_agencies_sort.key !== "asc"){
                                            new_sort = { key : 'asc', value : { a : 1, b : -1 }};
                                        }else{
                                            new_sort = {key : 'desc', value : { a : -1, b : 1 }}
                                        }
                                        this.setState({
                                            top_agencies_filter : filter,
                                            top_agencies_sort : new_sort
                                        })
                                    }}>ADR
                                    <Icon 
                                        type={this.state.top_agencies_sort.key === 'desc' ? "arrow-down" : 'arrow-up'} 
                                        style={{display : this.state.top_agencies_filter === 'adr' ? 'inline-block' : 'none'}}/>
                                    </span>
                                    <span className="row-grid rev cursor-sort" onClick={() => {
                                        let new_sort = {};
                                        let filter = 'revenue';
                                        if(this.state.top_agencies_sort.key !== "asc"){
                                            new_sort = { key : 'asc', value : { a : 1, b : -1 }};
                                        }else{
                                            new_sort = {key : 'desc', value : { a : -1, b : 1 }}
                                        }
                                        this.setState({
                                            top_agencies_filter : filter,
                                            top_agencies_sort : new_sort
                                        })
                                    }}>REV
                                    <Icon 
                                        type={this.state.top_agencies_sort.key === 'desc' ? "arrow-down" : 'arrow-up'} 
                                        style={{display : this.state.top_agencies_filter === 'revenue' ? 'inline-block' : 'none'}}/>
                                    </span>
                                </div>
                                <div className="col-md-12 datagrid-list scroll-table">
                                    {this.state.top_agency_table}
                                </div>
                                <div className="col-md-12 datagrid-list">
                                    {this.state.top_agency_totals}
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default TopProducers



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/TopProducers.js